(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('ReleveCompteurValidateConfirmController', ReleveCompteurValidateConfirmController);

    ReleveCompteurValidateConfirmController.$inject = ['$uibModalInstance'];

    function ReleveCompteurValidateConfirmController($uibModalInstance) {
        var vm = this;

        vm.clear = clear;
        vm.confirmValidation = confirmValidation;
        vm.confirmationInput = '';
        vm.confirmationText = 'I confirm';
        vm.isConfirmationValid = isConfirmationValid;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmValidation() {
            if (!isConfirmationValid()) {
                return;
            }

            $uibModalInstance.close(true);
        }

        function isConfirmationValid() {
            return (vm.confirmationInput || '').trim() === vm.confirmationText;
        }
    }
})();
